import { PayloadListAbstract } from 'src/domain/PayloadListAbstract';

export class StocksListPayload extends PayloadListAbstract {
  constructor () {
    super();
    this.filters = {
      ean: null,
      [StocksListPayload.API_FILTERS_KEYS.WAREHOUSE]: null,
      [StocksListPayload.API_FILTERS_KEYS.AVALIABILITY]: null
    };
  }

  static get API_FILTERS_KEYS () {
    return {
      EAN: 'ean',
      WAREHOUSE: 'warehouse',
      AVAILABILITY: 'availability'
    };
  }
}
